module.exports = __webpack_public_path__ + "img/card_icon_two.1a116fb7.png";